import React from "react";
import {
	BrowserRouter,
	Routes,
	Route,
	Link,
} from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import Home from "./components/Home";
import News from "./components/News";
import TopDrawer from "./components/TopDrawer/TopDrawer";
import DealAdvisory from "./components/Beratungsfelder/DealAdvisory/DealAdvisory";
import Beratungsfelder from "./components/Beratungsfelder/Beratungsfelder";
import Fokusthema from "./components/Beratungsfelder/Fokusthema/Fokusthema";
import GRCAdvisory from "./components/Beratungsfelder/GRCAdvisory/GRCAdvisory";
import CorporateAdvisory from "./components/Beratungsfelder/CorporateAdvisory/CorporateAdvisory";
import ESGAdvisory from "./components/Beratungsfelder/ESGAdvisory/ESGAdvisory";
import Unternehmen from "./components/Unternehmen/Unternehmen";
import ManagementTeam from "./components/Unternehmen/ManagementTeam/ManagementTeam";
import Blog from "./components/Unternehmen/Blog/Blog";
import Kooperationspartner from "./components/Unternehmen/Kooperationspartner/Kooperationspartner";
import Karriere from "./components/Unternehmen/Karriere/Karriere";
import Referenzen from "./components/Unternehmen/Referenzen/Referenzen";
import FullBlog from "./components/Unternehmen/Blog/FullBlog";
import NewsView from "./components/Unternehmen/NewsView/NewsView";
import FooterSec from "./components/Footer/FooterSec";
import Impressum from "./components/Footer/Impressum";
import Kontakt from "./components/Kontakt/Kontakt";
import MenuBar from "./components/TopDrawer/MenuBar";
import BeratungsfelderMenu from "./components/Beratungsfelder/BeratungsfelderMenu";
// import Digitalisierungs from "./components/Beratungsfelder/Digitalisierungs/Digitalisierungs";
import Produckt from "./components/Beratungsfelder/Digitalisierungs/Produckt";
import Services from "./components/Beratungsfelder/Unternehmen/Services";

// import OrgaCheck from "./components/Beratungsfelder/Fokusthema/OrgaCheck";

function App() {
	// console.log = function () { };

	return (
		<>
			<div className="appBody">
				{/* <BrowserRouter basename="/feingeist-beratung.de"> */}
				<BrowserRouter>
					<TopDrawer />

					<Routes>
						<Route path="news" element={<News />} />
						<Route path="impressum" element={<Impressum />} />
						<Route path="kontakt" element={<Kontakt />} />
						<Route path="managment_team" element={<ManagementTeam />} />
						<Route path="produkt" element={<Produckt />} />
						<Route path="service" element={<Services />} />


						<Route path="beratungsfelder">
							<Route index element={<Beratungsfelder />} />
							<Route path="deal_advisory" element={<DealAdvisory />} />
							<Route path="deal_advisory/:subType" element={<DealAdvisory />} />
							<Route path="fokusthema" element={<Fokusthema />} />
							<Route path="fokusthema/:subType" element={<Fokusthema />} />
							<Route path="grc" element={<GRCAdvisory />} />
							<Route path="corporate_advisory" element={<CorporateAdvisory />} />
							<Route path="esg_advisory" element={<ESGAdvisory />} />
							<Route path="esg_advisory/:subType" element={<ESGAdvisory />} />
						</Route>
						<Route path="beratungsfelder2">
							<Route index element={<Beratungsfelder />} />
							<Route path=":type/*" element={<BeratungsfelderMenu />} />
						</Route>
						<Route path="unternehmen">
							<Route index element={<Unternehmen />} />
							<Route path="managment_team" element={<ManagementTeam />} />
							<Route path="blog/:blogId" element={<FullBlog />} />
							<Route path="blog" element={<Blog />} />
							<Route path="news/:newsId" element={<NewsView />} />
							<Route path="kooperationspartner" element={<Kooperationspartner />} />
							<Route path="karriere" element={<Karriere />} />
							<Route path="referenzen" element={<Referenzen />} />
						</Route>
						<Route path="*" element={<Home />} />
					</Routes>

					<FooterSec />
				</BrowserRouter>
			</div>
		</>
	);
}

export default App;

